/* eslint-disable */
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import axios from 'axios';
import useGlobalStore from './store.js';

// const wa_authKey = localStorage.getItem('wa_auth_key');

// // const host = "https://oiomni.com/api"
// let parsedUrl = new URL(window.location.href);

// const host = parsedUrl.protocol + '//' + parsedUrl.hostname + '/api'
// const bssp_host = 'https://sms.bulksmsserviceproviders.com/api/';
// const bssp_authKey = "46a57c629565ac350bae4264c3e82d9e"
// const headers = {
//     "headers": {
//         'Authorization': `Bearer ${localStorage.getItem('token')}`,
//         'Access-Control-Allow-Origin': '*',
//         'Content-Type': 'application/json',
//         'Accept': "application/json",
//         'mode': 'no-cors',
//     }
// }

export const useAllFlow = () => {
    const { headers, host } = useGlobalStore();
    return useQuery({
        queryKey: ['allFlow'],
        queryFn: async () => {
            try {
                const response = await axios.get(host + '/get_all_flow', headers);
                return response.data;
            } catch (error) {
                throw error;
            }
        },
    })
};

export const useAllSch = () => {
    const { headers, host } = useGlobalStore();
    return useQuery({
        queryKey: ['allSch'],
        queryFn: async () => {
            try {
                const response = await axios.get(host + '/get_all_sch', headers);
                return response.data;
            } catch (error) {
                throw error;
            }
        },
    })
};

export const useAllWebhook = () => {
    const { headers, host } = useGlobalStore();
    return useQuery({
        queryKey: ['webhook'],
        queryFn: async () => {
            try {
                const response = await axios.get(host + "/webhookGet", headers);
                if (response.data && response.data.data && response.data.data != []) {
                    return response.data.data;
                } else {
                    return []
                }
            } catch (error) {
                throw error;
            }
        },
    })
};

export const useThirdParty = () => {
    const { headers, host } = useGlobalStore();
    return useQuery({
        queryKey: ['third_party_setup'],
        queryFn: async () => {
            try {
                const response = await axios.get(host + "/third_party_list/bssp", headers);
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
    })
}


export const useWaTag = (empID, prevEmpID) => {
    const { headers, wa_authKey } = useGlobalStore();

    return useQuery({
        queryKey: ["employeeTag", empID],
        queryFn: async () => {
            const response = await axios.post("https://tickmaker.io/api/get-tags", { auth_key: wa_authKey, employee_id: empID, }, headers);
            return response.data.data;
        },
        enabled: !!empID && empID !== prevEmpID,
        staleTime: 5 * 60 * 1000,
    })
};

export const useWaTemp = () => {
    const { headers, wa_authKey } = useGlobalStore();

    return useQuery({
        queryKey: ['wa_temp'],
        queryFn: async () => {
            try {
                const response = await axios.post('https://tickmaker.io/api/get-templates', {
                    "auth_key": wa_authKey,
                    "template_type": "template"
                }, headers);
                return response.data;
            } catch (error) {
                throw error;
            }
        },
    })
};

export const useEmp = () => {
    const { headers, wa_authKey } = useGlobalStore();

    return useQuery({
        queryKey: ['wa_emp'],
        queryFn: async () => {
            try {
                const response = await axios.post("https://tickmaker.io/api/get-role-employee", { "auth_key": wa_authKey, }, headers);
                return response.data;
            } catch (error) {
                throw error;
            }
        },
    })
};

export const useTemp = () => {
    const { headers, host } = useGlobalStore();

    return useQuery({
        queryKey: ['all_temp'],
        queryFn: async () => {
            try {
                const response = await axios.post(host + '/get_all_template_api/', {}, headers);
                return response.data;
            } catch (error) {
                throw error;
            }
        },
    })
};

export const useWaInter = () => {
    const { headers, wa_authKey } = useGlobalStore();

    return useQuery({
        queryKey: ['wa_inter'],
        queryFn: async () => {
            try {
                const response = await axios.post('https://tickmaker.io/api/get-templates', {
                    "auth_key": wa_authKey,
                    "template_type": "interactive"
                }, headers);

                // console.log(response.data)
                return response.data;
            } catch (error) {
                throw error;
            }
        },
    })
};

export const useWebhook = () => {
    const { headers, host } = useGlobalStore();

    return useQuery({
        queryKey: ['webhookDetails'],
        queryFn: async () => {
            try {
                const response = await axios.get(host + "/webhookGet", headers);
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
    })
};

export const useFunnel = () => {
    const { headers, host } = useGlobalStore();

    return useQuery({
        queryKey: ['funnel'],
        queryFn: async () => {
            try {
                const response = await axios.post(host + '/funnel_data/', {}, headers);
                return response.data;
            } catch (error) {
                throw error;
            }
        },
    })
}

export const useBsspSender = () => {
    const { headers, bssp_host, bssp_authKey } = useGlobalStore();

    return useQuery({
        queryKey: ['bsspSender'],
        queryFn: async () => {
            try {
                const response = await axios.post(bssp_host + 'get_senderid_api', { "auth_key": bssp_authKey }, headers);
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
    })
}

export const usePhonebookQuery = () => {
    const { headers, bssp_host, bssp_authKey } = useGlobalStore();

    return useQuery({
        queryKey: ['phonebook'],
        queryFn: async () => {
            try {
                const response = await axios.post(bssp_host + 'get_phonebook', { "auth_key": bssp_authKey }, headers);
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
    })
}

export const useBsspTemp = () => {
    const { headers, bssp_host, bssp_authKey } = useGlobalStore();

    return useQuery({
        queryKey: ['bsspTemp'],
        queryFn: async () => {
            try {
                const response = await axios.post(bssp_host + 'get_temps_api', { "auth_key": bssp_authKey }, headers);
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
    })
}

export const useUserDetail = () => {
    const { headers, host } = useGlobalStore();
    // console.log(headers)
    return useQuery({
        queryKey: ['userDetails'],
        queryFn: async () => {
            try {
                const response = await axios.get(host + '/user_details', headers);
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
    })
}

export const useEmailSender = () => {
    const { headers, host, bssp_authKey } = useGlobalStore();

    return useQuery({
        queryKey: ['emailSenders'],
        queryFn: async () => {
            try {
                const response = await axios.post(host + '/emailSender', { "bssp_auth_key": bssp_authKey }, headers);
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
    })
}

export const useLogDetail = (id, run_id) => {
    const { headers, host } = useGlobalStore();

    return  useQuery({
        queryKey: ['reportPre', run_id],
        queryFn: async () => {
            try {
                const response = await axios.post(host + '/report_preview', { "flow_id": id, "run_id": run_id }, headers);
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        placeholderData: keepPreviousData,
    })
}
